<template>
  <div class="page" :class="{'bosch-activity' : userType !== 1}">
    <div class="bg" >
      <!-- 滚动播报 -->
      <div class="scroll-box">
        <van-icon name="point-gift-o" class="icon" />
        <van-notice-bar color="#111111" :scrollable="true" :text="scrollText">
        </van-notice-bar>
      </div>
      <!-- 集齐BOSCH卡牌 -->
      <div class="group_1">
        <div class="text-center">
          <div
            :class="[
              {'compose-active-button' : canCompose},
              {'compose-button':!canCompose},
              {'activity-expiration' : isActivityfinished}
            ]"
            style="margin-top: 57px;"
            @click="handleCompositeCards">合成卡牌</div>
        </div>
        <div class="bosch-cards">
          <div :class="item.count === 0 ? 'no-card-drawn' : 'card-drawn'" v-for="item in collectPieceList"
            :key="item.text">
            <template v-if="item.count > 0">
              <div class="card-num">{{ item.count }}</div>
              <div class="card-text" v-if="item.count > 0">{{ item.pieceCode }}</div>
            </template>
          </div>
        </div>
        <div class="group_1-tips">
          <img :src="require('@/assets/images/activity/collect-cards/group_1_3.png')" alt="" width="100%" class="group_1-tips-img"  v-if=" userType === 1">
          <template  v-else>
            <img :src="require('@/assets/images/activity/collect-cards/group_1_2.png')" alt="" width="100%" class="group_1-tips-img">
            <div class="group_1-tip-1">扫博世产品二维码可获得卡牌</div>
            <div class="group_1-tip-2" >前往<span class="color-orange" v-if="userType === 2">开思平台</span>
              <span class="color-orange" v-if="userType === 3">康众平台</span>
              <span class="color-orange" v-if="userType === 4">开思/康众平台</span>购买博世产品，还可获得额外卡牌</div>
          </template>
        </div>
        <div class="bosch-buttons">
          <div class="scan-button" :class="{ 'activity-expiration' : isActivityfinished }" @click="scanCode">立即扫码</div>
          <div class="view-card-button" :class="{ 'activity-expiration' : isActivityfinished }" @click="jumpRecord">查看我的卡牌</div>
        </div>
      </div>
      <!-- 卡王排名 -->
      <div class="group_2">
        <div class="text-center group_2__title">
          您已集齐<span class="color-orange">{{ clientRankingList.prizeCount || 0 }}</span>次BOSCH
        </div>
        <div class="rank_1 rank" >
          <template v-if="rankTop3List[0]">
            <div class="rank-top-name van-ellipsis">{{rankTop3List[0].clientName}}</div>
            <div class="rank-top-count van-ellipsis">已集齐<span class="color-orange">{{rankTop3List[0].prizeCount || 0}}</span>次BOSCH</div>
          </template>
          <div class="rank-top-name" v-else>未上榜</div>
        </div>
        <div class="rank_2 rank">
          <template v-if="rankTop3List[1]">
          <div class="rank-top-name van-ellipsis">{{rankTop3List[1].clientName}}</div>
          <div class="rank-top-count van-ellipsis">已集齐<span class="color-orange">{{rankTop3List[1].prizeCount || 0}}</span>次BOSCH</div>
          </template>
          <div class="rank-top-name" v-else>未上榜</div>
        </div>
        <div class="rank_3 rank" >
          <template v-if="rankTop3List[2]">
          <div class="rank-top-name van-ellipsis">{{rankTop3List[2].clientName}}</div>
          <div class="rank-top-count van-ellipsis">已集齐<span class="color-orange">{{rankTop3List[2].prizeCount || 0}}</span>次BOSCH</div>
        </template>
          <div class="rank-top-name" v-else>未上榜</div>
        </div>
        <div class="rank-text">集齐BOSCH次数最多的<span class="color-orange">前3名</span>可获得88888积分！</div>
        <div class="rank-view-button" :class="{ 'activity-expiration' : isActivityfinished }" @click="jumpRank">全部排名</div>
      </div>
      <!-- 活动规则 -->
      <div class="group_3" :style="{'background-image' : rulePic}"></div>
    </div>
    <!-- 合成卡牌 -->
    <ActivityCollectCardsCompose ref="ActivityCollectCardsCompose" :list="composeList"></ActivityCollectCardsCompose>

    <!-- 获得卡牌 -->
    <ActivityCollectCardsGet
    ref="ActivityCollectCardsGet"
    :getPieceList="getPieceList"
    :bonusPointValue="bonusPointValue"
    :showActivityButton="false"
    @after-scan="getCardActivityInfo"></ActivityCollectCardsGet>

    <!-- 活动结束 -->
    <van-dialog v-model="finishedDialog" :confirmButtonColor="'#117281'">
      <div style="padding:20px;text-align: center;">
        活动已结束，您共合成卡牌 {{collectPieceCount}} 张，<br/>
        获得卡券 {{ awardCount }} 张，请尽快使用！</div>
  </van-dialog>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
import { scanCode } from '@/utils/carzoneapp'
import { Dialog } from 'vant'
import ActivityCollectCardsCompose from './components/activity-collectCards-compose.vue'
import ActivityCollectCardsGet from './components/activity-collectCards-get.vue'
export default {
  components: {
    ActivityCollectCardsCompose,
    ActivityCollectCardsGet
  },
  data () {
    return {
      clientInfo: null,
      prizeList: [],
      collectPieceList: [],
      clientRankingList: {
        'alreadySign': false,
        'clientId': '',
        'createDate': 0,
        'prizeCount': '',
        'ranking': ''
      },
      rankingList: [],
      rankTop3List: ['', '', ''],
      getPieceList: [],
      canCompose: false,
      composeList: [],
      userType: 1, // 1 易家；2开思；3 康众; 4 康众/开思
      bonusPointValue: 0,
      isActivityfinished: false,
      finishedDialog: false,
      awardCount: 0,
      collectPieceCount: 0
    }
  },
  watch: {
    'collectPieceList': {
      immediate: true,
      handler (val) {
        let boschArr = ['B', 'O', 'S', 'C', 'H']
        this.canCompose = (() => {
          for (let i = 0; i < this.collectPieceList.length; i++) {
            if (boschArr.includes(this.collectPieceList[i].pieceCode)) {
              if (this.collectPieceList[i].count < 1) {
                return false
              }
            }
          }
          return true
        })()
        this.collectPieceCount = this.collectPieceList.reduce((pre, item) => {
          return pre + item.count
        }, 0)
      }
    }
  },
  computed: {
    scrollText () {
      let name = this.prizeList.map((item) => {
        return '恭喜' + item.clientName + '获得:' + item.itemName + '   。   '
      }).join('')
      return name
    },
    rulePic () {
      if (this.userType === 1) {
        return `url(${require('@/assets/images/activity/collect-cards/rule_1.png')})`
      } else if (this.userType === 2) {
        return `url(${require('@/assets/images/activity/collect-cards/rule_2.png')})`
      } else if (this.userType === 3) {
        return `url(${require('@/assets/images/activity/collect-cards/rule_3.png')})`
      } else if (this.userType === 4) {
        return `url(${require('@/assets/images/activity/collect-cards/rule_4.png')})`
      } else {
        return `url(${require('@/assets/images/activity/collect-cards/rule_1.png')})`
      }
    }
  },
  created () {
    this.clientInfo = userUtils.getClientInfo() || ''
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })
    this.getCardActivityInfo()
    this.getCardRankList()
    const nowDate = new Date()
    // const nowDate = new Date('2023-06-16T23:59:59')
    const endDate = new Date('2023-06-15T23:59:59')
    if (nowDate - endDate > 0) {
      // 活动结束
      this.isActivityfinished = true
      this.getAwardCard()
    } else {
      this.isActivityfinished = false
    }
  },
  mounted () {
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    if (isIOS && location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
    commonUtils.reportViewTrace()
  },
  methods: {
    // 活动信息
    getCardActivityInfo () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      activityApi.getCardActivityInfo().then(res => {
        if (res.data.resultCode === '0') {
          const { prizeList, collectPieceList, isCASS, isKZ } = res.data.resultData
          if (isCASS === '1' && isKZ === '1') {
            this.userType = 4
          } else if (isCASS === '1' && isKZ !== '1') {
            this.userType = 2
          } else if (isCASS !== '1' && isKZ === '1') {
            this.userType = 3
          } else {
            this.userType = 1
          }
          this.prizeList = prizeList || []
          this.collectPieceList = collectPieceList || []
        }
        this.$toast.clear()
      }).catch(() => {
        this.$toast.clear()
      })
    },
    // 活动排名
    getCardRankList () {
      const params = {
        page: 1,
        pageSize: 10
      }
      activityApi.getCardRankList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.clientRankingList = res.data.resultData.clientRankingList || {}
          this.rankingList = res.data.resultData.rankingList || []
          for (let i = 0; i < this.rankingList.length; i++) {
            if (this.rankingList[i].ranking === '1') {
              this.rankTop3List[0] = this.rankingList[i]
            }
            if (this.rankingList[i].ranking === '2') {
              this.rankTop3List[1] = this.rankingList[i]
            }
            if (this.rankingList[i].ranking === '3') {
              this.rankTop3List[2] = this.rankingList[i]
            }
          }
        }
      })
    },
    // 扫码
    scanCode () {
      if (this.isActivityfinished) return
      if (!this.clientInfo) {
        Dialog.alert({
          title: '提示',
          message: '您当前尚未登陆，请前往登录页面登录'
        }).then(() => {
          this.$router.push({ name: 'login2', params: { redirectUrl: this.$route.name } })
        })
      } else {
        var u = navigator.userAgent
        let isCZ = u.match(/czbu/i)
        if (isCZ) {
          // 康众扫码
          scanCode().then(res => {
            this.scanResult({
              scanCode: res
            })
          }).catch(res => {
            this.$toast('调用扫码功能异常')
            console.log('err', res)
          })
        } else {
          this.$wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
            success: res => {
              let scanData = {
                scanCode: res.resultStr
              }
              console.log('scanData', res)
              this.getLocation(scanData)
            },
            fail: res => {
              this.$toast('调用扫码功能异常')
              console.log('fail', res)
            },
            cancel: function () {
              console.log('scan cancel')
            }
          })
        }
      }
    },
    // 获取经纬度
    getLocation (scanData) {
      this.$wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          scanData.locLat = res.latitude // 纬度，浮点数，范围为90 ~ -90
          scanData.locLong = res.longitude // 经度，浮点数，范围为180 ~ -180。
          this.scanResult(scanData)
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },
    // 扫码结果
    scanResult (value) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi.scanFirstHalf2022(value).then(res => {
        this.$toast.clear()
        console.log(res)
        if (res.data.resultCode === '0') {
          const { getPieceList, scanInfo } = res.data.resultData
          this.bonusPointValue = (scanInfo && scanInfo.bonusPointValue) || 0
          if (res.data.resultData.martTrayInfo) {
            this.trayInfo = res.data.resultData.martTrayInfo
            this.showTrayInfoPop = true
          } else if (getPieceList && getPieceList.length) {
            this.getPieceList = getPieceList
            this.$refs['ActivityCollectCardsGet'].open()
          } else {
            Dialog.confirm({
              title: '扫码成功',
              message: '扫码成功,恭喜你获得50易加积分',
              showCancelButton: false
            })
            if (res.data.resultData.activityPrize) {
              this.popUpDisplay.dialog = true
              this.popUpDisplay.activityPrize = res.data.resultData.activityPrize
            }
          }
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    // 合成卡牌
    handleCompositeCards () {
      if (this.isActivityfinished) return
      if (!this.canCompose) return
      const counts = this.collectPieceList.map(item => {
        return item.count
      })
      let count = Math.min(...counts)
      if (count > 0) {
        this.$toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true
        })
        const params = {
          count: count >= 10 ? 10 : count
        }
        activityApi.LotteryCards(params).then(res => {
          if (res.data.resultCode === '0') {
            const { prizeList } = res.data.resultData
            this.composeList = prizeList || []
            this.$refs['ActivityCollectCardsCompose'].open()
            this.getCardActivityInfo()
            this.getCardRankList()
          }
          this.$toast.clear()
        }).catch(() => {
          this.$toast.clear()
        })
      } else {}
    },
    jumpRecord () {
      if (this.isActivityfinished) return
      this.$router.push({ name: 'activity-collectCards-record' })
    },
    jumpRank () {
      if (this.isActivityfinished) return
      this.$router.push({ name: 'activity-collectCards-ranking' })
    },
    // 获奖记录
    getAwardCard () {
      let dataParams = {
        page: 1,
        pageSize: 1
      }
      activityApi.getCardAwardList(dataParams).then(res => {
        if (res.data.resultCode === '0') {
          const { pageInfo } = res.data.resultData
          this.awardCount = pageInfo.totalCounts || 0
          this.finishedDialog = true
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.page {
  position: relative;
  width: 100%;
  height: 1700px;
  overflow: hidden;
  padding-top: 0;
  background-color: rgb(17, 74, 83) ;
  .bg {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: url('../../../assets/images/activity/collect-cards/bg-index.png') no-repeat;
    background-size: 100% auto;
    z-index: 1;
    padding: 16px;
    box-sizing: border-box;
    color: #fff;

    .group_1 {
      width: 100%;
      height: 363px;
      background: url('../../../assets/images/activity/collect-cards/group_1.png') no-repeat;
      background-size: 100% auto;
      box-sizing: border-box;
      .group_1-tips{
        position: relative;
        font-size: 10px;
        .group_1-tips-img{
          padding: 0px 10px 20px 10px;
          box-sizing: border-box;
        }
        .group_1-tip-1{
          position:absolute;
          top: 16%;
          left: 16%;
        }
        .group_1-tip-2{
          position:absolute;
          top: 39%;
          left: 16%;
        }
      }
    }

    .group_2 {
      position: relative;
      width: 100%;
      height: 397px;
      background: url('../../../assets/images/activity/collect-cards/group_2.png') no-repeat;
      background-size: 100% auto;
      padding: 5px;
      box-sizing: border-box;
      margin-top: 25px;
      &__title{
        position: absolute;
        top: 17%;
        left: 30%;
      }
      .rank_2 {
        position: absolute;
        top: 118px;
        left: 16px;
      }

      .rank_1 {
        position: absolute;
        top: 101px;
        left: 121px;
      }

      .rank_3 {
        position: absolute;
        top: 118px;
        left: 224px;
      }

      .rank {
        display: inline-block;
        text-align: center;
        width: 100px;
        height: 142px;

        .rank-top-name {
          font-size: 14px;
          line-height: 20px;
          width: 90px;
          margin-left: 5px;
          padding-top:65px ;
        }

        .rank-top-count {
          font-size: 10px;
        }

      }

      .rank-text {
        width: 100%;
        font-size: 12px;
        position: absolute;
        left: 13%;
        top: 73%;
      }
       .rank-view-button{
        font-size: 0px;
        width: 137px;
        height: 41px;
        background: url('../../../assets/images/activity/collect-cards/rank-button.png') no-repeat;
        background-size: 100% auto;
        display: inline-block;
        position: absolute;
        bottom: 8%;
        left: 30%;
      }
    }

    .group_3 {
      width: 100%;
      height: 500px;
      background: url('../../../assets/images/activity/collect-cards/group_3.png') no-repeat;
      background-size: 100% auto;
      padding: 5px;
      box-sizing: border-box;
      margin-top: 25px;

      .activity-rule {
        margin-top: 50px;
        padding: 0px 15px;
        font-size: 13px;

        p {
          text-indent: -16px;
          margin-left: 16px;
          +p {
            margin-top: 8px;
          }
        }
      }
    }
  }
}
.bosch-activity{
  height: 1800px !important ;
  .bg{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: url('../../../assets/images/activity/collect-cards/bg-bosch.png') no-repeat;
    background-size: 100% auto;
    z-index: 1;
    padding: 16px;
    box-sizing: border-box;
    color: #fff;
    .group_1 {
      width: 100%;
      height: 382px;
      background: url('../../../assets/images/activity/collect-cards/group_1_1.png') no-repeat;
      background-size: 100% auto;
      box-sizing: border-box;
    }
  }
}
.scroll-box {
  margin-top: 254px;
  margin-bottom: 150px;
  margin-left: auto;
  margin-right: auto;
  width: 313px;
  height: 20px;
  position: relative;

  .icon {
    color: #fff;
    position: absolute;
    bottom: 3.5px;
    left: 10px;
    z-index: 2;

  }

  /deep/ .van-notice-bar {
    background: rgba(42, 42, 42, 0.505) !important;
    border-radius: 20px;
    height: 20px;
    line-height: 20px;
    padding-left: 30px;
    padding-right: 5px;
  }

  /deep/ .van-notice-bar__content {
    font-size: 10px;
    color: #fff;
  }

}

.color-orange {
  color: #F1990A;
}
.bosch-cards{
  min-height: 86px;
}
.activity-expiration{
  filter: grayscale(100%);
}
</style>
<style lang="less">

</style>
